export const withGcTime = <T extends object>(options: T, gcTime?: number) =>
  gcTime === undefined ? options : { ...options, gcTime };
